import { DefaultSelection36RfiDuedatePayload, IRFIDueDate } from "../api-generated";

export default class RFIDueDateDetails
  implements IRFIDueDate
{
  public Guid?: string;
  public DueDate?: string | null;
  public InternalDueDate?: string | null;

  constructor(item?: DefaultSelection36RfiDuedatePayload) {

    this.Guid = item?.Guid;

    this.DueDate = item?.DueDate;

    this.InternalDueDate = item?.InternalDueDate;
  }
}
